import NavbarSidebarWrapper from "../../components/navbarSidebarWrapper";
import { useCallback, useEffect, useState } from "react";
import actions from "../../redux/actions";
import { useSelector } from "react-redux";
import ScreenLoader from "../../components/ScreenLoader";
import { notifyError, notifySuccess } from "../../components/ToastContext";
import FnTableWrapper from "../../components/ViewMatchContests/FnTableWrapper";
import FnCreateContestsForm from "../../components/Models/FnCreateContestsForm";

const ViewFantacyContests = () => {
  let data = useSelector((state) => state.fantacyMatch?.allContestList);
  let marketIdsList = useSelector((state) => state.match?.marketIdsList?.Result);

  const [action, setAction] = useState(true);
  const [loader, setLoader] = useState(true);
  const [selectedMatchIds, setSelectedMatchIds] = useState([]);
  const [showModal, setShowModal] = useState(false); // 👈 Modal state

  const handleScheduleList = async () => {
    setLoader(true);
    try {
      let res = await actions.getAllContestList();
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Failed to load contest list");
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Failed to load contest list");
    }
    setLoader(false);
  };

  useEffect(() => {
    handleScheduleList();
  }, []);

  const onSelectionChange = useCallback((ids) => {
    setSelectedMatchIds(ids);
  }, []);

  // 👇 When contest form submits
  const handleContestSubmit = async (formData) => {
    try {
      setLoader(true);

      const payload = {
        ...formData,
        matchIds: selectedMatchIds, // attach selected matches
      };

      let res = await actions.postCreateContest(payload); // API
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Contest creation failed");
        setLoader(false);
      } else {
        notifySuccess("Contest created successfully");
        setShowModal(false);
        setLoader(false);
        handleScheduleList(); // refresh list
      }
    } catch (err) {
      setLoader(false);
      notifyError(err?.response?.data?.Result || err.message || "Contest creation failed");
    }
  };

  return (
    <NavbarSidebarWrapper>
      <div>
        <div className="content-header-btn mb-2">
          View Fantasy Match
          <button className={"custom-green-btn"}
            data-toggle="modal"
            data-target="#createContestModal"
            onClick={() => setShowModal(true)} style={{ fontSize: "13px" }}>
            Create Contest
          </button>
        </div>
        <div className="tab-content">
          <div className="tab-pane fade show active" id="tab2">
            <FnTableWrapper
              data={data}
              marketIdsList={marketIdsList}
              showAction={action}
              onSelectionChange={onSelectionChange}
            />
          </div>

          {loader && <ScreenLoader />}
        </div>
      </div>

      {/* 👇 Modal Here */}
      <FnCreateContestsForm
        show={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleContestSubmit}
      />
    </NavbarSidebarWrapper>
  );
};

export default ViewFantacyContests;
